import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ToastContainer from './ui/ToastContainer';
import PageTransition from './ui/PageTransition';

interface LayoutProps {
  children: React.ReactNode;
  openSignIn: () => void;
  openSignUp: () => void;
  toastData?: {
    message: string;
    type: 'success' | 'error' | 'info' | 'warning';
  } | null;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  openSignIn,
  openSignUp,
  toastData
}) => {
  return (
    <div className="flex flex-col min-h-screen bg-background overflow-x-hidden">
      <a
        href="#main-content"
        className="sr-only focus-visible:not-sr-only focus-visible:fixed focus-visible:top-2 focus-visible:left-2 focus-visible:z-50 focus-visible:px-4 focus-visible:py-2 focus-visible:bg-primary focus-visible:text-primary-foreground focus-visible:rounded-lg focus-visible:shadow-lg focus-visible:text-sm focus-visible:font-medium"
      >
        Skip to content
      </a>
      <Header openSignIn={openSignIn} openSignUp={openSignUp} />

      <main id="main-content" className="flex-grow">
        <PageTransition>
          {children}
        </PageTransition>
      </main>

      <Footer />

      {/* Legacy toast notification system */}
      {toastData && (
        <div className={`toast toast-top toast-end`}>
          <div className={`alert alert-${toastData.type}`}>
            {toastData.message}
          </div>
        </div>
      )}

      {/* Toast notification system */}
      <ToastContainer />
    </div>
  );
};

export default Layout;